import { formatMonthlyPrice } from './pricing';

export function mapSubscriptionFromApi(subscription) {
  if (!subscription) {
    return null;
  }

  const product = subscription.product || {};
  const rawPlanId =
    subscription.planId ||
    product.planId ||
    product.productId ||
    product._id ||
    subscription.product ||
    subscription.id ||
    subscription._id ||
    null;
  const planId = rawPlanId ? String(rawPlanId) : null;

  const rawPrice =
    product.priceAmount !== undefined
      ? Number(product.priceAmount)
      : product.price !== undefined
      ? Number(product.price)
      : null;
  const planPriceAmount = Number.isFinite(rawPrice) ? rawPrice : null;

  const rawPeriod =
    product.billingPeriod !== undefined
      ? Number(product.billingPeriod)
      : product.period !== undefined
      ? Number(product.period)
      : null;
  const planBillingPeriod = Number.isFinite(rawPeriod) && rawPeriod > 0 ? rawPeriod : 1;
  const planBillingUnit = product.billingUnit || product.periodUnit || 'month';

  const planPriceDisplay =
    planPriceAmount != null
      ? formatMonthlyPrice(planPriceAmount, planBillingPeriod, planBillingUnit)
      : null;

  const rawQuotaLimit = Number(subscription.quotaLimit);
  const normalizedQuotaLimit =
    Number.isFinite(rawQuotaLimit) && rawQuotaLimit > 0 ? rawQuotaLimit : null;
  const rawQuotaUsed = Number(subscription.quotaUsed) || 0;
  const quotaRemaining =
    subscription.quotaRemaining != null
      ? Number(subscription.quotaRemaining)
      : normalizedQuotaLimit != null
      ? Math.max(normalizedQuotaLimit - rawQuotaUsed, 0)
      : null;
  const isQuotaExhausted =
    Boolean(subscription.quotaExhausted) ||
    (normalizedQuotaLimit != null && quotaRemaining === 0);

  return {
    planId,
    planName: product.name || product.description || subscription.planName || 'Credit Plan',
    planPriceAmount,
    planBillingPeriod,
    planBillingUnit,
    planFeatures: Array.isArray(product.features) ? product.features : [],
    planPriceDisplay,
    approvedAt: subscription.startsAt || subscription.createdAt || subscription.approvedAt || null,
    startsAt: subscription.startsAt || null,
    endsAt: subscription.endsAt || null,
    createdAt: subscription.createdAt || null,
    productId: planId,
    status: subscription.status || 'approved',
    queuePosition:
      subscription.queuePosition != null ? Number(subscription.queuePosition) : null,
    userName: subscription.userName || null,
    quotaLimit: normalizedQuotaLimit,
    quotaUsed: rawQuotaUsed,
    quotaRemaining,
    isQuotaExhausted,
  };
}

export function mapSubscriptionsFromApi(subscriptions) {
  if (!Array.isArray(subscriptions)) {
    return [];
  }

  return subscriptions
    .map((subscription) => mapSubscriptionFromApi(subscription))
    .filter(Boolean);
}

export default {
  mapSubscriptionFromApi,
  mapSubscriptionsFromApi,
};
